import { useCallback, useState } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { ContentPromotionGoalsDialog } from '../../../ContentPromotionGoalsDialog/ContentPromotionGoalsDialog';
import { ContentPromotionBudgetGoal } from '../ContentPromotionBudgetGoal/ContentPromotionBudgetGoal';
import { AddGoalButton, Wrapper } from './styles';
import { ContentPromotionBudgetGoalsProps } from './types';

export const ContentPromotionBudgetGoals: React.FC<ContentPromotionBudgetGoalsProps> = ({
    goals: goalsBase,
    selectedCounters,
    selectedGoals,
    hiddenBudgetValue,
    showCostType,
    onSelect,
    onRemove,
    onChange,
    onChangeCostType,
    ...other
}) => {
    const t = useTranslation();

    const [visibleGoalsDialog, setVisibleGoaldDialog] = useState(false);
    const closeGoalsDialog = useCallback(() => setVisibleGoaldDialog(false), []);
    const openGoalsDialog = useCallback(() => setVisibleGoaldDialog(true), []);

    const goals = goalsBase.filter((goal) => selectedCounters.indexOf(goal.counterId) !== -1);
    const selectedGoalsIds = selectedGoals && Object.keys(selectedGoals);
    const selected = goals.filter((goal) => selectedGoalsIds?.indexOf(goal.id) !== -1);

    return (
        <>
            <Wrapper {...other}>
                <Flex direction="row" alignItems="center">
                    <Typography variant="body" weight="bold">
                        {t('Целевые действия и их цена')}
                    </Typography>
                </Flex>
                <Typography variant="body" pt={2}>
                    {t(
                        'Добавьте хотя бы по одной цели со счётчика для сайта — это нужно для подбора наиболее конверсионного трафика',
                    )}
                </Typography>
                {selected ? (
                    <Flex width="100%" pt={1}>
                        {selected.map((goal) => (
                            <ContentPromotionBudgetGoal
                                key={goal.id}
                                py={2}
                                goal={goal}
                                value={selectedGoals?.[goal.id].cost}
                                costType={selectedGoals?.[goal.id].costType}
                                hiddenValue={hiddenBudgetValue}
                                showCostType={showCostType}
                                onRemove={onRemove}
                                onChange={onChange}
                                onChangeCostType={onChangeCostType}
                            />
                        ))}
                    </Flex>
                ) : null}
                <AddGoalButton mt={2} disabled={!goals.length} onClick={openGoalsDialog}>
                    {t('Добавить цель')}
                </AddGoalButton>
            </Wrapper>
            {visibleGoalsDialog ? (
                <ContentPromotionGoalsDialog
                    goals={goals}
                    selected={selectedGoalsIds}
                    onSelect={onSelect}
                    onClose={closeGoalsDialog}
                />
            ) : null}
        </>
    );
};
